const appConfig = window.ASOS.myAccount;
export default appConfig;
